import "./App.css";
import "./fonts.css";
import Landing from "./components/Landing";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import FloatingContact from "./components/subcomponents/FloatingContact";
import { projects } from "./data";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);
  
  return (
    <>
      <HelmetProvider>

      <Helmet>
      <title>Laurence Lama | Business Web & AI Systems</title>
      <meta name="description" content="Laurence Lama builds business websites, AI workflows, dashboards, and ecommerce systems that help owners turn scattered tools into clearer, faster operations." />
      <link rel="canonical" href="https://www.laurencelama.com/" />
      <meta property="og:title" content="Laurence Lama | Business Web & AI Systems" />
      <meta property="og:description" content="Business websites, AI workflows, dashboards, and ecommerce systems that help owners turn scattered tools into clearer, faster operations." />
      <meta property="og:url" content="https://www.laurencelama.com/" />
      <meta property="og:image" content="https://www.laurencelama.com/og-image.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Laurence Lama | Business Web & AI Systems" />
      <meta name="twitter:description" content="Business websites, AI workflows, dashboards, and ecommerce systems that help owners turn scattered tools into clearer, faster operations." />
      <meta name="twitter:image" content="https://www.laurencelama.com/og-image.png" />
      <meta name="keywords" content="Laurence, Laurence Lama, AI systems, automation dashboard, ecommerce developer, Shopify developer, web developer, business analytics dashboard, video editing" />
      </Helmet>

      <Landing />
      
      <main>
      <FloatingContact />
      <Services />
      <Projects projects={projects} />
      <Testimonials />
      <Contact />
      </main>

      <Footer />

      </HelmetProvider>
    </>
  );
}

export default App;
